import React, { Component } from 'react';
import PropTypes from 'prop-types';


import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';

const s:any = {
  master: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
    //width: 200,
  },
  hide:{
    display:'none',
  },
}


class FDisplayField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value 
    };
  }

  handleChange = () => {
    // let value = event.target.value;
    // this.props.onChange(value);
    // this.setState({value});
  };

  render() {
    const {id,label,divider,classes } = this.props;

    return (
      <Box sx={{...s.master}}>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            multiline={true}
            minRows={1}
            fullWidth={true}
            sx={{...s.textField}}
            value={this.state.value}
            inputProps={
              { readOnly: true, }
            }
            //onChange={this.handleChange}
          />
        {divider && <Divider />}
      </Box>
    );
  }
}

FDisplayField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FDisplayField;
